import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
	ModalFooter,
} from 'reactstrap';

// import { deleteResidue } from '../../../../slices/thunks';

// import { setRequireCloseModal } from '../../../../slices/residue/reducer';

import { useSelector, useDispatch } from 'react-redux';
import { warehouseReceptionGuide } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

const ConfirmReceptionModal = ({ guidesReception, isOpen, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorGuides = createSelector(
		state => state.Guides,
		guideDetail => ({
			isReceiving: guideDetail.isReceiving,
			isReceived: guideDetail.isReceived,
			isReceptionError: guideDetail.isReceptionError,
			requireCloseModal: guideDetail.requireCloseModal
		})
	);

	const {
		isReceiving,
		isReceived,
		isReceptionError,
		requireCloseModal
	} = useSelector(selectorGuides);


	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: false,
		initialValues: {
			guides: guidesReception
		},
		validationSchema: Yup.object({
		}),
		onSubmit: values => {
			const dataGuides = {
				guides: guidesReception
			};
			dispatch(warehouseReceptionGuide(dataGuides));
		},
	});

	function handlerOkModal() {
		validation.submitForm();
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader>
					Confirmar Recepción
				</ModalHeader>
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>

					<lord-icon src="https://cdn.lordicon.com/hrqwmuhr.json"
						trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: "120px", height: "120px" }}>
					</lord-icon>
					<div className='mt-2'>
						<h5 className='mb-3'>
							¡Atención! Estás a punto de confirmar la recepción de los residuos seleccionados
						</h5>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='hstack gap-2 justify-content-center'>
						<Button className='btn-danger btn-label' onClick={() => handlerToggleModal()}><i className="icon-x label-icon"></i> Cerrar</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={() => handlerOkModal()}
							disabled={isReceiving}>
							{isReceiving ? <i className='label-icon'><Spinner size='sm' /></i> : <i className={`${Icons.check2} label-icon`}></i>}
							Confirmar
						</button>
					</div>
				</ModalFooter>
			</Modal>
		</div>
	);
};

export default ConfirmReceptionModal;
